// Contrats du studio : sorties fermées, versions immuables et gestes sous version.
import { z } from 'zod';
export const TYPES_TEXTE_STUDIO = [
    'communique',
    'texte_salle',
    'presentation_expo',
    'publication_reseaux',
    'lettre_information',
    'libre',
];
export const typeTexteStudioSchema = z.enum(TYPES_TEXTE_STUDIO);
export const sourceStudioSchema = z
    .strictObject({
    type: z.enum(['exposition', 'oeuvres', 'artiste', 'libre']),
    ids: z
        .array(z
        .string()
        .regex(/^[a-f\d]{24}$/i)
        .toLowerCase())
        .max(20),
})
    .refine((s) => new Set(s.ids).size === s.ids.length &&
    (s.type === 'libre'
        ? s.ids.length === 0
        : s.type === 'oeuvres'
            ? s.ids.length >= 1
            : s.ids.length === 1), 'Choisissez les sources dans cette galerie.');
export const contenuStudioSchema = z.strictObject({
    titre: z.string().max(500),
    chapo: z.string().max(2000),
    corps: z.string().min(1).max(16000),
});
const avecChapo = contenuStudioSchema.extend({
    titre: z.string().min(1).max(500),
    aVerifier: z.array(z.string().max(500)).max(30),
});
const sansChapo = avecChapo.extend({ chapo: z.literal('') });
// Trois paragraphes indépendants représentent les trois variantes, sans mot-dièse ajouté.
export const SORTIES_STUDIO = {
    communique: avecChapo.clone(),
    texte_salle: sansChapo.clone(),
    presentation_expo: avecChapo.clone(),
    publication_reseaux: avecChapo.extend({
        titre: z.literal(''),
        chapo: z.literal(''),
        corps: z.string().refine((s) => {
            const variantes = s.split(/\n\s*\n/);
            return (variantes.length === 3 && variantes.every((v) => v.trim().length > 0 && v.length <= 600));
        }, 'Trois variantes de 600 caractères au plus, séparées par une ligne vide.'),
    }),
    lettre_information: avecChapo.clone(),
    libre: sansChapo.clone(),
};
export const creationStudioSchema = z.strictObject({
    type: typeTexteStudioSchema,
    titreInterne: z.string().trim().min(1).max(120),
    source: sourceStudioSchema,
    brief: z.string().trim().max(2000),
    langue: z.enum(['fr', 'en']),
    longueur: z.enum(['courte', 'moyenne', 'longue']),
    mentionnerPrixPublics: z.boolean().default(false),
});
export const versionStudioSchema = z.strictObject({ version: z.int().positive() });
export const choixVersionStudioSchema = versionStudioSchema.extend({ n: z.int().positive() });
export const retoucheStudioSchema = choixVersionStudioSchema.extend({
    consigne: z.string().trim().min(1).max(300),
});
export const modificationStudioSchema = versionStudioSchema.extend({
    contenu: contenuStudioSchema,
    aVerifier: z.array(z.string().max(500)).max(30),
});
export const utilisationStudioSchema = versionStudioSchema.extend({
    type: z.enum(['copie', 'telechargement', 'actualite']),
});
export const filtresStudioSchema = z.object({
    type: typeTexteStudioSchema.optional(),
    etat: z.enum(['brouillon', 'valide', 'archive']).optional(),
    langue: z.enum(['fr', 'en']).optional(),
    source: z.enum(['exposition', 'oeuvres', 'artiste', 'libre']).optional(),
    q: z.string().trim().max(120).optional(),
    page: z.coerce.number().int().min(1).max(100000).default(1),
});
export const versionTexteStudioSchema = z.strictObject({
    n: z.int().positive(),
    contenu: contenuStudioSchema,
    aVerifier: z.array(z.string()),
    origine: z.enum(['ia', 'humain', 'traduction']),
    consigne: z.string().nullable(),
    appelId: z.string().nullable(),
    creePar: z.string(),
    creeLe: z.iso.datetime(),
});
export const texteStudioSchema = creationStudioSchema.extend({
    id: z.string(),
    etat: z.enum(['brouillon', 'valide', 'archive']),
    versions: z.array(versionTexteStudioSchema).min(1).max(20),
    versionValidee: z.int().positive().nullable(),
    traductionDe: z.string().nullable(),
    traductions: z.strictObject({ fr: z.string().optional(), en: z.string().optional() }),
    utilisations: z.array(z.strictObject({
        type: z.enum(['copie', 'telechargement', 'actualite']),
        le: z.iso.datetime(),
        par: z.string(),
        postId: z.string().optional(),
    })),
    creePar: z.string(),
    creeLe: z.iso.datetime(),
    modifieLe: z.iso.datetime(),
    version: z.int().positive(),
});
export const listeStudioSchema = z.strictObject({
    textes: z.array(texteStudioSchema),
    page: z.int().positive(),
    total: z.int().nonnegative(),
});
export function texteBrutStudio(contenu) {
    return [contenu.titre, contenu.chapo, contenu.corps].filter(Boolean).join('\n\n');
}
//# sourceMappingURL=studio.js.map